export default __webpack_public_path__ + "static/media/marketingg.50cadabf.png";